import { type StreamTrace } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import {
	type MessageTemplate,
	type Trace,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

export const getTraceFromStreamMessage = (streamMessage: StreamTrace): Trace => {
	return {
		messageContent: streamMessage.message?.content,
		messageTemplate: streamMessage.message?.message_template as MessageTemplate,
	};
};
